(function () {
  'use strict';
  if (window.__STByobDateGuardHardStop) return;
  window.__STByobDateGuardHardStop = true;
  var allowUntil = 0;
  var knownBoxes = {'43147450581063':true,'43147449270343':true,'43147449532487':true,'43236321329223':true,'43236317298759':true};
  var style = document.createElement('style');
  style.textContent = '.st-byob-dateguard-cart .additional-checkout-buttons,.st-byob-dateguard-cart .shopify-payment-button{display:none!important}';
  (document.head || document.documentElement).appendChild(style);
  function dateKey(v) {
    var s=String(v||'').trim(), m=s.match(/(\d{4})[-\/](\d{1,2})[-\/](\d{1,2})/);
    if(m)return m[1]+'-'+m[2].padStart(2,'0')+'-'+m[3].padStart(2,'0');
    m=s.match(/(\d{1,2})\/(\d{1,2})\/(\d{4})/);
    return m?m[3]+'-'+m[1].padStart(2,'0')+'-'+m[2].padStart(2,'0'):'';
  }
  function boxLine(item) {
    var p=item&&item.properties||{};
    return !!knownBoxes[String(item.variant_id||'')] || /new\s*byob/i.test(String(p['_Cupcake Source']||'')) || /^STBYOB-/i.test(String(p['Box ID']||''));
  }
  function attr(cart,key) {
    var a=cart&&cart.attributes||{}, target=key.toLowerCase().replace(/[\s_-]/g,'');
    var actual=Object.keys(a).find(function(k){return k.toLowerCase().replace(/[\s_-]/g,'')===target;});
    return actual?String(a[actual]||''):'';
  }
  function check(cart) {
    var boxes=(cart&&cart.items||[]).filter(boxLine);
    document.documentElement.classList.toggle('st-byob-dateguard-cart',boxes.length>0);
    if(!boxes.length)return '';
    var dates=boxes.map(function(item){var p=item.properties||{};return dateKey(p['Pickup Date']||p['Pickup-Date']);});
    if(dates.some(function(d){return !d;}))return 'A Build Your Own Box is missing its pickup date. Please remove that box and rebuild it with the correct date.';
    var unique=Array.from(new Set(dates));
    if(unique.length!==1)return 'Your Build Your Own Boxes have different pickup dates. Please place separate orders or rebuild the boxes so they all use the same date.';
    var pickup=dateKey(attr(cart,'Pickup-Date'));
    if(!pickup)return 'Please select your pickup date and time in the pickup calendar before checkout. The date must match your Build Your Own Box.';
    if(pickup!==unique[0])return 'Pickup dates do not match. Your box is for '+unique[0]+', but the pickup calendar shows '+pickup+'. Please correct the date before checkout.';
    return '';
  }
  function getCart(){return fetch('/cart.js',{headers:{Accept:'application/json'},cache:'no-store'}).then(function(r){if(!r.ok)throw Error('cart');return r.json();});}
  function warn(message) {
    var existing=document.getElementById('stByobHardStopMessage');
    if(!existing){existing=document.createElement('div');existing.id='stByobHardStopMessage';existing.setAttribute('role','alertdialog');existing.style.cssText='position:fixed;inset:0;z-index:2147483647;background:rgba(0,0,0,.55);display:flex;align-items:center;justify-content:center;padding:20px';existing.innerHTML='<div style="max-width:460px;padding:28px;border-radius:16px;background:white;color:#361d13;text-align:center"><p id="stByobHardStopText" style="font-size:18px;line-height:1.5"></p><button type="button" id="stByobHardStopOK" style="border:0;border-radius:24px;background:#361d13;color:white;padding:12px 32px">OK</button></div>';document.body.appendChild(existing);existing.querySelector('button').addEventListener('click',function(){existing.style.display='none';});}
    existing.querySelector('#stByobHardStopText').textContent=message;
    existing.style.display='flex';
  }
  function validateThen(proceed) {
    getCart().then(function(cart){var error=check(cart);if(error){warn(error);return;}allowUntil=Date.now()+2500;proceed();}).catch(function(){warn('We could not confirm your pickup date. Please refresh your cart and select the pickup date before checkout.');});
  }
  document.addEventListener('click',function(e){
    var button=e.target&&e.target.closest&&e.target.closest('#CheckOut,button[name="checkout"],input[name="checkout"],a[href$="/checkout"]');
    if(!button||Date.now()<allowUntil)return;
    e.preventDefault();e.stopImmediatePropagation();
    validateThen(function(){button.click();});
  },true);
  document.addEventListener('submit',function(e){
    var form=e.target;
    if(!form||form.id!=='cart'||Date.now()<allowUntil)return;
    e.preventDefault();e.stopImmediatePropagation();
    validateThen(function(){if(form.requestSubmit)form.requestSubmit();});
  },true);
  function refresh(){getCart().then(check).catch(function(){});}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',refresh,{once:true});else refresh();
  document.addEventListener('change',function(){setTimeout(refresh,150);},true);
  window.addEventListener('pageshow',refresh);
})();